module.exports = __webpack_public_path__ + "fonts/Manrope-500-latin-ext11_1a780b6.woff2";